import { FC, ReactNode } from 'react';

export type SectionHeaderProps = {
  title: string;
  description?: ReactNode;
  /** The section's action, placed at the end of the header. */
  action?: ReactNode;
  /** Placement only: typography, spacing and stacking are the header's. */
  className?: string;
};

/**
 * A section header inside a page.
 *
 * The same layout as PageHeader at the h2/section-title role, for a page that
 * is embedded in a larger shell and must not open a second h1.
 */
const SectionHeader: FC<SectionHeaderProps> = ({ title, description, action, className }) => (
  <header className={['ui-section-header', className].filter(Boolean).join(' ')}>
    <div className="ui-section-header-text">
      <h2 className="ui-section-title">{title}</h2>
      {description && <p className="ui-section-desc">{description}</p>}
    </div>
    {action}
  </header>
);

export default SectionHeader;
